var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoFixHigh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5013 7.5L20.4413 5.44L22.5013 4.5L20.4413 3.56L19.5013 1.5L18.5613 3.56L16.5013 4.5L18.5613 5.44L19.5013 7.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00128 7.5L8.94128 5.44L11.0013 4.5L8.94128 3.56L8.00128 1.5L7.06128 3.56L5.00128 4.5L7.06128 5.44L8.00128 7.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5013 13L18.5613 15.06L16.5013 16L18.5613 16.94L19.5013 19L20.4413 16.94L22.5013 16L20.4413 15.06L19.5013 13Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2113 9.62L14.3813 6.79C14.1813 6.6 13.9313 6.5 13.6713 6.5C13.4113 6.5 13.1613 6.6 12.9613 6.79L1.79128 17.96C1.40128 18.35 1.40128 18.98 1.79128 19.37L4.62128 22.2C4.82128 22.4 5.07128 22.5 5.33128 22.5C5.59128 22.5 5.84128 22.4 6.04128 22.21L17.2113 11.04C17.6013 10.65 17.6013 10.01 17.2113 9.62ZM13.6713 8.92L15.0813 10.33L13.9113 11.5L12.5013 10.09L13.6713 8.92ZM5.33128 20.09L3.92128 18.68L11.0913 11.5L12.5013 12.91L5.33128 20.09Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoFixHigh);
export default __webpack_public_path__ + "static/media/auto_fix_high.a3cad5922b169d711e3fa46bf7cf5422.svg";
export { ForwardRef as ReactComponent };